<script setup lang="ts"></script>

<template>
  <div class="l-organization">
    <router-view />
  </div>
</template>

<style scoped lang="scss"></style>
